<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        @if(loaderIcon | async){
            <app-loader></app-loader>
        }
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Product Category</h5>
                <button class="btn btnAS" [userPermissionHandler]="createPermissionHandlerData" (click)="openCreateCategoryModal()">NEW</button>
            </div>
            <hr />
            <div class="container-fluid p2-3">
                <div class="mb-3 d-flex gap-3 align-items-center">
                    <form [formGroup]="productCategory">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" id="rdAll" formControlName="rdocategory" type="radio"
                                name="status" value="0" (change)="loadFilteredList()" />
                            <label class="form-check-label" for="rdAll">All</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" id="rdActive" formControlName="rdocategory" type="radio"
                                name="status" value="1" (change)="loadFilteredList()" />
                            <label class="form-check-label" for="rdActive">Active</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" id="rdInactive" formControlName="rdocategory" type="radio"
                                name="status" value="2" (change)="loadFilteredList()" />
                            <label class="form-check-label" for="rdInactive">Inactive</label>
                        </div>
                    </form>
                </div>
                <ejs-grid #gridProductCategory [dataSource]="categoriesList" [allowFiltering]="true" height="300"
                    class="mt-2" (created)='created($event)' (dataBound)='dataBound($event)'
                    (rowSelected)="onProductCategoryRowSelected($event)">
                    <e-columns>
                        <e-column field="category" headerText="Product Category" textAlign="Left"
                            width="210"></e-column>
                        <e-column field="color" headerText="Color" textAlign="Center" width="130">
                            <ng-template #template let-data>
                                <div class="color-box mx-auto" [ngStyle]="{ 'background-color': data.color }"></div>
                            </ng-template>
                        </e-column>
                        <e-column field="activeInactive" headerText="Active / Inactive" textAlign="Center" width="140">
                            <ng-template #template let-data>
                                <span class="status-dot" [ngStyle]="{
                                    'background-color': data.activeInactive ? inactiveColor:activeColor
                                  }"></span>
                            </ng-template>
                        </e-column>
                        <e-column field="Delete" headerText="Delete" width="80" textAlign="Center">
                            <ng-template #template let-data>
                                    <button class="btn btn-link w-100 h-100 p-0"
                                    [userPermissionHandler]="deletePermissionHandlerData"
                                    (click)="$event.stopPropagation(); $event.preventDefault(); deleteProductCategory(data.id)">
                                    <img src="./assets/images/delete.svg" class="img-fluid"/>
                                  </button>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="productCategoryModal" #productCategoryModal tabindex="-1"
    aria-labelledby="productCategoryModalLabel" aria-hidden="true">
    <form [formGroup]="createProductCategory">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="productCategoryModalLabel">Product Category</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="productCategory" class="form-label">Product Category</label>
                        <input type="text" id="productCategory" maxlength="30" class="form-control"
                            formControlName="productCategoryName" />
                    </div>
                    <div class="mb-3">
                        <label for="colorSelect" class="form-label">Color</label>
                        <input id="txtColor" class="form-control" list type="color" formControlName="selectedColor"
                            maxlength="10">
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="activeCheckbox"
                            formControlName="categoryActive" (change)="checkProductSetForCategory()" name="active" />
                        <label class="form-check-label" for="activeCheckbox">
                            Active
                        </label>
                    </div>
                </div>
                <div class="modal-footer">
                    @if (isEditMode) {
                        <button type="button" class="btn btnAS" [userPermissionHandler]="editPermissionHandlerData" [disabled]="disableNewCategorySave() || disableSave" (click)="saveProductCategory()">
                          Save
                        </button>
                      } @else {
                        <button type="button" class="btn btnAS" [userPermissionHandler]="createPermissionHandlerData" [disabled]="disableNewCategorySave() || disableSave" (click)="saveProductCategory()">
                          Save
                        </button>
                      }
                    <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </form>
</div>